import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

import {
  Box,
  ButtonTextLink,
  Container,
  InfoMessageExpandTrigger,
  LayoutVertical,
  StepCard,
  Typography,
} from "@/components";
import { SUPPORT_URLS } from "@/constants";

import { MailAddressChangeAuthMailForm } from "./components/MailAddressChange/Forms";

export const MailAddressChangeAuthMail = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <Helmet title={t("CHANGE_EMAIL")} />
      <LayoutVertical>
        <Typography variant="h1">{t("CHANGE_EMAIL")}</Typography>
        <StepCard activestep={2} steplength={5}>
          <Typography variant="h2" gutterBottom>
            {t("PLEASE_INPUT_NEW_EMAIL")}
          </Typography>
          <Typography component="h3" variant="body1">
            {t("SEND_CONFIRM_MAIL")}
          </Typography>
          <InfoMessageExpandTrigger label="CHECK_EMAIL_NOTICE">
            <Typography sx={{ whiteSpace: "pre-line" }}>{t("INVALID_EMAIL_ADDRESS_NOTICE_MESSAGE_0")}</Typography>
            <ol style={{ paddingLeft: "16px" }}>
              <li>{t("INVALID_EMAIL_ADDRESS_NOTICE_MESSAGE_1")}</li>
              <li>{t("INVALID_EMAIL_ADDRESS_NOTICE_MESSAGE_2")}</li>
            </ol>
            <Typography sx={{ whiteSpace: "pre-line", mb: "16px" }}>
              {t("INVALID_EMAIL_ADDRESS_NOTICE_MESSAGE_3")}
            </Typography>
            <ButtonTextLink
              to={SUPPORT_URLS.crew.ABOUT_NON_ARRIVAL_OF_CREW_PORTAL_CONFIRMATION_EMAIL}
              target="_blank"
              sx={{ textAlign: "left", textDecoration: "underline" }}
              isTargetBlankFixed
            >
              {t("ABOUT_NON_ARRIVAL_OF_CREW_PORTAL_CONFIRMATION_EMAIL")}
            </ButtonTextLink>
          </InfoMessageExpandTrigger>
          <Box textAlign="center">
            <MailAddressChangeAuthMailForm />
          </Box>
        </StepCard>
      </LayoutVertical>
    </Container>
  );
};
